/* eslint-disable no-new */
import WOW from 'wow.js';
import SlideInMenu from './components/SlideInMenu';
import SwipperJS from './components/SwipperJS';
import TartoSetup from './components/TartoSetup';
import Alert from './components/Alert';
import Accordion from './components/Accordion';
import Exhibitors from './components/Exhibitors';
import LightboxPicture from './components/LightboxPicture';
import Modale from './components/Modale';
import ExhibitorRegistrationJs from './components/ExhibitorRegistrationJs';
import ExhibitorSelectPackage from './components/ExhibitorSelectPackage';
import ParticipantRegistration from './components/ParticipantRegistration';
import Office from './components/Office';
import Shop from './components/Shop';

document.addEventListener('DOMContentLoaded', () => {
    new WOW({ mobile: false }).init();
    new SwipperJS();
    new TartoSetup();
    new Alert();
    new Accordion();
    new SlideInMenu();
    new Exhibitors();
    new LightboxPicture();
    new Modale();
    new ExhibitorRegistrationJs();
    new ExhibitorSelectPackage();
    new ParticipantRegistration();
    new Office();
    new Shop();
});
